// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    AddAccount,
    AddAccountParameter,
    chain,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { xngAddAccount } from "@keller/App/Services/AccountService";

export interface XngAddAccountParameter extends AddAccountParameter {
    formData: FormData;
}

export const XngAddAccount: typeof AddAccount = async props => {
    stopWatchingForOtherTabSessionChange();
    props.apiResult = await xngAddAccount((props.parameter as XngAddAccountParameter).formData);
    watchForOtherTabSessionChange();
};

replaceInChain(chain, AddAccount, XngAddAccount);
